<template>
  <v-container>
    <h1>{{ $store.getters.sourceDictionaryName }} / Categories</h1>
    <CategoriesTable  v-on:edit="edit($event)"></CategoriesTable>
    <CategoryDialog v-model="dialog" :model="model"></CategoryDialog>
    <v-btn
            fixed
            dark
            fab
            right
            bottom
            color="pink"
            v-on:click="create"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import CategoriesTable from '../components/CategoriesTable'
import CategoryDialog from '../components/CategoryDialog'

export default {
  components: { CategoryDialog, CategoriesTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    create () {
      this.model = null
      this.dialog = true
    },
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
